exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ledgerEntry {\r\n    background-color: lightsteelblue;\r\n    border: 1 solid steelblue;\r\n    border-radius: 3px;\r\n    margin-top: 2px;\r\n    padding: 2px;\r\n}\r\n\r\n.after {\r\n    background-color: palegreen;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Customer/customerLedger.component.css
// module id = 441
// module chunks = 1